import React, { useLayoutEffect, useState } from 'react';
import { InputFieldWrapper } from '@components-shared/forms/FieldLabel';
import cn from 'classnames';
import { BaseEditor } from 'components/shared/HtmlEditor';
import { EmptyObject } from '../shared.interfaces';
import { Attributes, FormType } from './formField.interface';

interface IProps {
  name: string;
  title: string;
  attributes?: Attributes;
  getAttributes?: (form?: FormType) => Attributes | EmptyObject;
  valid: boolean;
  validationMessage: string;
  form?: FormType;
  required?: boolean;
  onChange: (name: string, value: string) => void;
  value: string;
  hintMessage?: string;
  testID?: string;
  tooltip?: string;
}

const Editor = (props: IProps) => {
  const {
    name,
    title,
    attributes,
    getAttributes,
    valid,
    testID = 'formEditor',
    validationMessage,
    form,
    hintMessage,
    required,
    value,
    onChange,
    tooltip,
  } = props;
  const [isEditorEnabled, setIsEditorEnabled] = useState<boolean>(false);

  useLayoutEffect(() => {
    setIsEditorEnabled(true);
  }, []);

  const onBlur = (value: string) => {
    onChange(name, value);
  };

  const attr = getAttributes ? { ...attributes, ...getAttributes(form) } : attributes;

  if (!isEditorEnabled) {
    return null;
  }

  return (
    <InputFieldWrapper
      name={name}
      className="rte"
      title={title}
      tooltip={tooltip}
      required={required}
      valid={valid}
      validationMessage={validationMessage}
      hintMessage={hintMessage}
      /* TODO The editor does not work correctly with the label in InputFieldWrapper.
         No option found to set an id for the ckEditor for now. */
      htmlFor="html-editor"
      testID={testID}>
      <div className={cn('form__editor', { invalid: !valid, disabled: attr?.disabled })}>
        <BaseEditor value={value} onChange={onBlur} isNeedPreview={false} />
      </div>
    </InputFieldWrapper>
  );
};

export default Editor;
